
import { Link } from 'react-router-dom';

export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center bg-cover bg-center" style={{ backgroundImage: 'url(https://static.readdy.ai/image/dc94b4331bde31366815bfe78425789e/ba686a4ffe2bcd006898a01ca3617512.jpeg)' }}>
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 text-center text-white w-full">
        <h2 className="text-5xl lg:text-7xl font-bold mb-6 leading-tight drop-shadow-[0_4px_8px_rgba(0,0,0,0.8)]">
          覚えられないを無くす
        </h2>
        <p className="text-xl lg:text-2xl mb-12 max-w-3xl mx-auto leading-relaxed drop-shadow-[0_2px_6px_rgba(0,0,0,0.7)]">
          独自の記憶メソッドとAIチューター・ゲームで<br />
          すべての人に学びの成功体験を
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button
            onClick={scrollToContact}
            className="bg-primary text-white px-10 py-4 hover:bg-accent transition-colors font-semibold whitespace-nowrap cursor-pointer inline-block"
          >
            お問い合わせ
          </button>
          <Link
            to="/features"
            className="bg-white text-primary px-10 py-4 hover:bg-gray-100 transition-colors font-semibold whitespace-nowrap cursor-pointer inline-block"
          >
            詳しく見る
          </Link>
        </div>
      </div>
    </section>
  );
}
